import { ChevronDown } from 'lucide-react';

export default function CollapsibleSection({ title, description, open, onToggle, children }) {
  return (
    <section className="rounded-2xl border border-[rgba(var(--border),0.35)] bg-[rgba(var(--subpanel),0.14)]">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
      >
        <div>
          <h3 className="text-sm font-semibold text-[rgb(var(--fg))]">{title}</h3>
          {description ? <p className="mt-1 text-xs text-[rgba(var(--muted),0.95)]">{description}</p> : null}
        </div>
        <ChevronDown className={`h-4 w-4 text-[rgba(var(--muted),0.95)] transition-transform ${open ? 'rotate-180' : ''}`} aria-hidden="true" />
      </button>
      {open ? <div className="border-t border-[rgba(var(--border),0.28)] px-4 py-3">{children}</div> : null}
    </section>
  );
}
